export const CONSTS = {
  text: $localize`Note: This report displays a maximum of %n rows only.`,
};
